import React from 'react';
import _ from 'lodash';
import routes from '../../constants/route';
import { useTranslation } from 'react-i18next';

const PrescriptionLeftMenu = ({
  sectionList = [],
  visibleSection = '',
  drugName = '',
  userPoints,
  pathname = ''
}) => {
  const { t } = useTranslation();
  const handleScrollNew = (e, elementId, isFocus) => {
    e.preventDefault();
    if (typeof window !== 'undefined') {
      window.history.pushState(
        {},
        `${drugName}${elementId}`,
        `${window.location.pathname}#${elementId}`
      );
    }
    document
      .getElementById(elementId)
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
    isFocus && _.setFocusWithoutReload(`#${elementId}`, 'a,button');
  };

  return (
    <div
      role="complementary"
      className={`leftListItem scrollMenu mobileScroll
      ${
        userPoints.amount > 1.0 &&
        !pathname.includes('/prescription/') &&
        !pathname.includes('/medicamento/') &&
        !routes.hideLoyalty.includes(pathname) &&
        'NavTop'
      }
          `}
    >
      <div className="aboutDrugBottomArea">
        <div className="aboutDrugTitle">
          {t('Learn more about')}&nbsp;<span>{drugName}</span>
        </div>
        <ul>
          {sectionList &&
            sectionList.map((item, index) => {
              return (
                <li
                  key={index}
                  className={
                    visibleSection === item.displayName ? 'active' : ''
                  }
                >
                  {item.link ? (
                    <a
                      target="_self"
                      href={item.link}
                      aria-current={visibleSection === item.displayName}
                    >
                      {item.displayName}
                    </a>
                  ) : (
                    <a
                      href={`#${item.id}`}
                      target="_self"
                      onClick={e => handleScrollNew(e, item.id, false)}
                      onKeyDown={e => {
                        if (e.key === 'Enter') {
                          handleScrollNew(e, item.id, true);
                        }
                      }}
                      aria-current={visibleSection === item.displayName}
                    >
                      {item.displayName}
                    </a>
                  )}
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};

export default PrescriptionLeftMenu;
